import ConfigServiceClinics from "../configs/ConfigServiceClinics";
import Cookies from "js-cookie";

const headers = () => ({ Authorization: Cookies.get("adminToken") });

const getClinicSandboxText = () =>
  ConfigServiceClinics.get("/api/admin/clinics/texts_sandbox", { headers: headers() });

const getAdminClinicInfoById = (clinicId) =>
  ConfigServiceClinics.get(`/api/admin/clinics/${clinicId}`, { headers: headers() });

const updateSandboxClinicText = ({ lang, clinicId, textAlias, text }) =>
  ConfigServiceClinics.put(
    `/api/admin/clinics/texts_sandbox/${lang}/clinic/${clinicId}/alias/${textAlias}`,
    { text },
    { headers: headers() }
  );

const setTextSandboxApproveStatus = ({ lang, clinicId }) =>
  ConfigServiceClinics.post(
    `/api/admin/clinics/texts_sandbox/${lang}/clinic/${clinicId}/approve`,
    {},
    { headers: headers() }
  );

const setTextSandboxDisapproveStatus = ({ lang, clinicId, alias }) =>
  ConfigServiceClinics.post(
    `/api/admin/clinics/texts_sandbox/${lang}/clinic/${clinicId}/disapprove`,
    { alias },
    { headers: headers() }
  );

export default {
  getClinicSandboxText,
  getAdminClinicInfoById,
  updateSandboxClinicText,
  setTextSandboxApproveStatus,
  setTextSandboxDisapproveStatus,
};
